import React, { useState, useRef } from 'react';
import { Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SearchForJob = () => {
    const [file, setFile] = useState<File | null>(null);
    const [isUploading, setIsUploading] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();

    const handleSearchClick = () => {
        // Programmatically trigger the click on the hidden file input
        fileInputRef.current?.click();
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setFile(event.target.files[0]);
        }
    };

    const handleUpload = async () => {
        if (!file) {
            alert("Please select a file to upload.");
            return;
        }

        setIsUploading(true);

        const formData = new FormData();
        formData.append('resume', file);

        try {
            console.log(formData);
            const response = await fetch('/api/canidateUpload', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                console.log(data)
                console.log("Data from recruiterUpload:", data);
                const searchUrl = `/results?docId=${data.jobDescriptionId}&docType=resume`;
                // You can now use searchData in this component if needed

                // Then navigate to the search page
                navigate(searchUrl);
            }
            else {
                throw new Error('Upload failed');
            }
        } catch (error) {
            console.log(error)
            console.error("Error uploading file:", error);
            alert("Error uploading file. Please try again.");
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="flex justify-center items-center w-full mt-8">
            <div className="relative w-full max-w-3xl">
                {/* Hidden File Input */}
                <input
                    type="file"
                    ref={fileInputRef}
                    accept='.pdf'
                    onChange={handleFileChange}
                    className="hidden" // Completely hide the file input
                />

                {/* Search Icon and Placeholder */}
                <div
                    onClick={handleSearchClick} // Trigger file input click
                    className="flex items-center w-full py-3 px-4 border border-gray-300 rounded-full shadow-md bg-white hover:border-blue-400 cursor-pointer"
                >
                    <Search className="text-gray-500 mr-4" size={24} aria-hidden="true" />
                    <span className="text-gray-500 flex-1 truncate">
                        {file?.name || 'Resume Not Selected'}
                    </span>

                </div>

                {/* Upload Button */}
                <button
                    onClick={handleUpload}
                    disabled={isUploading}
                    className={`mt-4 w-full py-3 rounded-full shadow-md text-white focus:outline-none focus:ring-2 focus:ring-blue-500 
                        ${isUploading
                            ? 'bg-gray-300 cursor-not-allowed'
                            : 'bg-blue-500 hover:bg-blue-600'
                        }`}
                    aria-disabled={isUploading}
                >
                    {isUploading ? 'Uploading...' : 'Upload Resume'}
                </button>
            </div>
        </div>
    );
};

export default SearchForJob;